import { render, staticRenderFns } from "./CorporateDetailSummary.vue?vue&type=template&id=30aa44c7&functional=true&"
import script from "./CorporateDetailSummary.vue?vue&type=script&lang=js&"
export * from "./CorporateDetailSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports